var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormColumns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 26H156V132H80V26Z",
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.1 30H83.9V128H152.1V30ZM80 26V132H156V26H80Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.286 45H93.7143C92.1363 45 90.8571 46.7909 90.8571 49V54C90.8571 56.2091 92.1363 58 93.7143 58H142.286C143.864 58 145.143 56.2091 145.143 54V49C145.143 46.7909 143.864 45 142.286 45ZM93.7143 41C90.5584 41 88 44.5817 88 49V54C88 58.4183 90.5584 62 93.7143 62H142.286C145.442 62 148 58.4183 148 54V49C148 44.5817 145.442 41 142.286 41H93.7143Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.286 72H93.7143C92.1363 72 90.8571 73.7909 90.8571 76V81C90.8571 83.2091 92.1363 85 93.7143 85H142.286C143.864 85 145.143 83.2091 145.143 81V76C145.143 73.7909 143.864 72 142.286 72ZM93.7143 68C90.5584 68 88 71.5817 88 76V81C88 85.4183 90.5584 89 93.7143 89H142.286C145.442 89 148 85.4183 148 81V76C148 71.5817 145.442 68 142.286 68H93.7143Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164 26H240V132H164V26Z",
    fill: "#4C6170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.1 30H167.9V128H236.1V30ZM164 26V132H240V26H164Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.286 45H177.714C176.136 45 174.857 46.7909 174.857 49V54C174.857 56.2091 176.136 58 177.714 58H226.286C227.864 58 229.143 56.2091 229.143 54V49C229.143 46.7909 227.864 45 226.286 45ZM177.714 41C174.558 41 172 44.5817 172 49V54C172 58.4183 174.558 62 177.714 62H226.286C229.442 62 232 58.4183 232 54V49C232 44.5817 229.442 41 226.286 41H177.714Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.286 72H177.714C176.136 72 174.857 73.7909 174.857 76V81C174.857 83.2091 176.136 85 177.714 85H226.286C227.864 85 229.143 83.2091 229.143 81V76C229.143 73.7909 227.864 72 226.286 72ZM177.714 68C174.558 68 172 71.5817 172 76V81C172 85.4183 174.558 89 177.714 89H226.286C229.442 89 232 85.4183 232 81V76C232 71.5817 229.442 68 226.286 68H177.714Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.286 99H93.7143C92.1363 99 90.8571 100.791 90.8571 103V108C90.8571 110.209 92.1363 112 93.7143 112H142.286C143.864 112 145.143 110.209 145.143 108V103C145.143 100.791 143.864 99 142.286 99ZM93.7143 95C90.5584 95 88 98.5817 88 103V108C88 112.418 90.5584 116 93.7143 116H142.286C145.442 116 148 112.418 148 108V103C148 98.5817 145.442 95 142.286 95H93.7143Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.286 99H177.714C176.136 99 174.857 100.791 174.857 103V108C174.857 110.209 176.136 112 177.714 112H226.286C227.864 112 229.143 110.209 229.143 108V103C229.143 100.791 227.864 99 226.286 99ZM177.714 95C174.558 95 172 98.5817 172 103V108C172 112.418 174.558 116 177.714 116H226.286C229.442 116 232 112.418 232 108V103C232 98.5817 229.442 95 226.286 95H177.714Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormColumns);
export default __webpack_public_path__ + "static/media/form-columns.0d08aa70e62c0f18378e8b85be8e23e7.svg";
export { ForwardRef as ReactComponent };